import { Component, OnInit } from '@angular/core';
import { PermitService, PermitDetailsModel } from '../services/permit.service';
import { ErrorHandlingService, AlertService, FormValidationService, FormValidator, ValidationError } from 'core-lib';
import { environment } from '../../environments/environment';

@Component({
  selector: 'cli-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent implements OnInit {

  public vm: HelpViewModel;
  private validator: FormValidator;

  constructor(private permitSvc: PermitService,
    private errorHandlingSvc: ErrorHandlingService,
    private alertSvc: AlertService,
    private formValidationSvc: FormValidationService) {

    this.vm = new HelpViewModel();
    this.validator = this.formValidationSvc.getFormValidator(this.vm);
  }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitSvc.model;

    this.permitSvc.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);

      this.vm.isLoading = false;
      this.vm.isOpening = false;
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);
        this.vm.isLoading = false;
        this.vm.isOpening = false;
      });
  }

  mapModel(vm: HelpViewModel, data: PermitDetailsModel) {
    vm.businessName = data.permitDetails.clientName;
    vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;
  }



  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }
}

export class HelpViewModel {

  constructor() {
    this.errors = [];
  }

  public isOpening: boolean;
  public isLoading: boolean;
  public businessName: string;
  public contactName: string;
  public permitNo: string;


  public errors: ValidationError[];
}
